import { Link } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import {
  TERMS_VERSION, PRIVACY_VERSION, LEGAL_EFFECTIVE, LEGAL_ENTITY, LEGAL_DBA, LEGAL_EMAIL,
  TERMS_SECTIONS, PRIVACY_SECTIONS,
} from "@/legal/content";

const LegalDoc = ({ title, version, sections, testId, other }) => (
  <div data-testid={testId} className="min-h-screen bg-background">
    <div className="bg-royal-deep sidebar-grain px-6 py-10 sm:px-10 sm:py-14">
      <div className="mx-auto max-w-3xl">
        <Link to="/login" data-testid="legal-back-link"
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-gold hover:text-white transition-colors duration-200">
          <ArrowLeft className="h-3.5 w-3.5" /> Back to Cornerstone Ops
        </Link>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-5">{title}</h1>
        <p className="text-blue-100/70 text-sm mt-3">
          {LEGAL_ENTITY} d/b/a {LEGAL_DBA} · Version {version} · Effective {LEGAL_EFFECTIVE}
        </p>
      </div>
    </div>
    <div className="mx-auto max-w-3xl px-6 py-10 sm:px-10">
      {sections.map((sec) => (
        <section key={sec.title} className="mb-7">
          <h2 className="font-display text-base md:text-lg font-semibold text-royal-deep">{sec.title}</h2>
          {sec.body.map((p, i) => (
            <p key={i} className="mt-2.5 text-sm leading-relaxed text-muted-foreground">{p}</p>
          ))}
        </section>
      ))}
      <div className="flex flex-wrap items-center gap-4 border-t border-border pt-6">
        <button type="button" data-testid="legal-print-btn" onClick={() => window.print()}
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-royal hover:text-gold transition-colors duration-200">
          <Printer className="h-3.5 w-3.5" /> Print or save as PDF
        </button>
        <Link to={other.to} data-testid="legal-other-link"
          className="text-xs font-semibold text-royal hover:text-gold transition-colors duration-200">
          {other.label}
        </Link>
        <a href={`mailto:${LEGAL_EMAIL}`} className="text-xs font-semibold text-muted-foreground hover:text-royal transition-colors duration-200">
          {LEGAL_EMAIL}
        </a>
      </div>
    </div>
  </div>
);

export const TermsPage = () => (
  <LegalDoc title="Terms of Service" version={TERMS_VERSION} sections={TERMS_SECTIONS}
    testId="terms-page" other={{ to: "/privacy", label: "Read the Privacy Policy" }} />
);

export const PrivacyPage = () => (
  <LegalDoc title="Privacy Policy" version={PRIVACY_VERSION} sections={PRIVACY_SECTIONS}
    testId="privacy-page" other={{ to: "/terms", label: "Read the Terms of Service" }} />
);

export default TermsPage;
